import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Typography, Chip } from '@mui/material';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import ActionsMenu from 'utils/ActionsMenuDatagrid';
import ActionLabels from 'utils/ActionLabelsDatagrid';
import CurrencyFormatter from 'utils/helpers/CurrencyFormatter';

export const PageNetPayHook = ({
  setHasSearched,
  netPayAction,
  cleanNetPayAction,
  detailNetPayAction,
  netPay,
  detailTransactionsNetpay,
  cleanDetailNetPayAction,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  reportTransactionsFraud,
  actionReportTransactionsChargeback,
  reportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const { payload } = netPay || {};
  const { response } = detailTransactionsNetpay || {};
  const { rows, pagination } = payload || {};

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState(false);
  const [isDialogOpenDetails, setIsDialogOpenDetails] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [action, setAction] = useState(null);
  const [openActionFraud, setOpenActionFraud] = useState(false);
  const [descriptionTransaction, setDescriptionTransaction] = useState('');
  const [loadingFraudAndChargeback, setLoadingFraudAndChargeback] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [error, setError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [IdOrder, setIDorder] = useState('');
  const [mappedRows, setMappedRows] = useState([]);

  useEffect(() => {
    if (transactionId) {
      // setLoading(true);
      setIsDialogOpenDetails(true);
      detailNetPayAction(transactionId);
    }
  }, [transactionId, detailNetPayAction, setIsDialogOpenDetails]);

  useEffect(() => {
    if (response?.response?.status > 200) {
      setIsDialogOpenDetails(true);
      setDialogMessage('Error');
      setDialogMessage(response?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [response]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      netPayAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    return () => {
      cleanNetPayAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, netPayAction, cleanNetPayAction]);

  useEffect(() => {
    if (netPay?.status === 200) {
      setLoading(false);
    } else if (netPay?.payload?.response?.status > 200) {
      setDialogMessage(netPay?.payload?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [netPay]);

  useEffect(() => {
    if (page === 0) {
      return;
    }

    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      netPayAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const onSubmit = (data) => {
    const { from_date, to_date, authorization_code, masked_pan_termination } = data;

    const areDatesProvided = from_date !== '' && to_date !== '';
    const isAuthorizationOrCardProvided =
      authorization_code !== '' || masked_pan_termination !== '';

    if (areDatesProvided || isAuthorizationOrCardProvided) {
      setLoading(true);
      const filteredData = Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(data).filter(([_, value]) => value !== ''),
      );
      setSearchParams(filteredData);
      setErrorMessage('');
    } else {
      setErrorMessage(
        'Por favor, complete al menos uno de los siguientes campos: autorización, tarjeta o ambas fechas.',
      );
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangePageSize = (newSize) => {
    setSize(newSize);
    setPage(1);
  };

  useEffect(() => {
    if (rows) {
      const updatedRows = rows.map((row) => ({
        ...row,
        id: `${row.id}`,
      }));
      setMappedRows(updatedRows);
    }
  }, [rows]);

  const handleIdButtonClick = (id) => {
    setIDorder(id);
    if (id) {
      setIsDialogOpenDetails(true);
      detailNetPayAction(id)
        .then(() => setLoading(false))
        .catch(() => {
          setDialogMessage('Error');
          setDialogMessage('Error al cargar los detalles de la transferencia.');
          setIsDialogOpen(true);
          setLoading(false);
        });

      return () => {
        cleanDetailNetPayAction();
      };
    }
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setIsDialogOpenDetails(false);
    cleanDetailNetPayAction();
    if (transactionId) {
      onClose();
    }
  };

  const getStatusColor = (paymentStatus) => {
    switch (paymentStatus) {
      case 'Success':
        return 'green';
      case 'Fail':
        return 'red';
      case 'Review':
        return 'Orange';
      default:
        return 'purple';
    }
  };

  const translationMap = {
    Requested: 'Transacción registrada',
    Success: 'Transacción exitosa',
    Fail: 'Falló al procesar el pago',
    Review: 'En espera de revisión',
    Error: 'Error al procesar el pago',
  };

  const handleFraudPrevention = (data) => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: data,
      descriptionTransaction,
      payment_provider_name: 'netpay',
    };
    actionReportTransactionsFraud({ ...payload });
  };

  const handleChargebackPrevention = (data) => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: data,
      descriptionTransaction,
      payment_provider_name: 'netpay',
    };
    actionReportTransactionsChargeback({ ...payload });
  };

  const handleCloseFraudChargeback = () => {
    setOpenActionFraud(false);
    setDescriptionTransaction('');
    setError(false);
    setDialogMessage('');

    if (action === 'fraud') {
      cleanReportTransactionsFraud();
    } else if (action === 'chargeback') {
      cleanReportPrepaidChargebackDetails();
    }

    setLoading(true);

    netPayAction(page, size, searchParams)
      .then(() => setLoading(false))

      .catch(() => {
        setLoading(false);
      });
  };

  const handleOpenPopUp = (action, rowId) => {
    setAction(action);
    setSelectedRowId(rowId);
    setOpenActionFraud(true);
  };

  const handleSubmitWithFlag = (onSubmit) => {
    return (...args) => {
      setHasSearched(true);
      return handleSubmit(onSubmit)(...args);
    };
  };

  const handleConfirm = () => {
    if (descriptionTransaction === '') {
      setError(true);
    } else {
      setError(false);
      if (action === 'fraud') {
        handleFraudPrevention(selectedRowId);
      } else if (action === 'chargeback') {
        handleChargebackPrevention(selectedRowId);
      }
    }
  };

  useEffect(() => {
    if (reportTransactionsChargeback?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailNetPayAction(IdOrder);
    } else if (reportTransactionsChargeback?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsChargeback?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsChargeback]);

  useEffect(() => {
    if (reportTransactionsFraud?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailNetPayAction(IdOrder);
    } else if (reportTransactionsFraud?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsFraud?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsFraud]);

  const Columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Button variant='outlined' onClick={() => handleIdButtonClick(params.row.id)}>
          {'Ver detalle'}
        </Button>
      ),
    },

    {
      field: 'prevention',
      headerName: 'Prevención',
      width: 200,
      headerAlign: 'center',
      renderCell: (params) => (
        <ActionLabels isFraud={params.row.is_fraud} isChargeback={params.row.is_chargeback} />
      ),
    },

    {
      field: 'created',
      headerName: 'Fecha DB',
      width: 250,

      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'installments',
      headerName: 'Mensualidades',
      width: 200,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => {
        const value = params.value;
        return value === 1 ? 'Contado' : `${value} meses`;
      },
    },
    {
      field: 'transaction_time',
      headerName: 'Fecha NetPay',
      width: 250,
      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'payment_status',
      headerName: 'Estado de pago',
      width: 220,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Chip
          label={translationMap[params.row.payment_status] || params.row.payment_status}
          style={{
            backgroundColor: getStatusColor(params.row.payment_status),
            color: 'white',
          }}
        />
      ),
    },

    {
      field: 'authorization_code',
      headerName: 'Autorización',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'unique_identifier',
      headerName: 'Identificador único',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'operation_id',
      headerName: 'ID de operación',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'masked_pan',
      headerName: 'Tarjeta',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'amount',
      headerName: 'Monto',
      width: 120,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => <CurrencyFormatter amount={params.value} />,
    },
    {
      field: 'reference',
      headerName: 'Referencia',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },

    {
      field: 'frictionless_confirmation',
      headerName: '3DS',
      width: 100,

      headerAlign: 'center',
      renderCell: (params) => (
        <Typography>{params.row.frictionless_confirmation ? 'SI' : 'NO'}</Typography>
      ),
    },
    {
      field: 'message',
      headerName: 'Mensaje',
      width: 200,

      headerAlign: 'center',
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 200,
      headerAlign: 'center',
      renderCell: (params) => (
        <ActionsMenu
          onFraud={() => handleOpenPopUp('fraud', params.id)}
          onChargeback={() => handleOpenPopUp('chargeback', params.id)}
        />
      ),
    },
  ];

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    page,
    size,
    pagination: {
      ...pagination,
      handleChangePage,
      handleChangePageSize,
    },
    rows,
    mappedRows,
    Columns,
    isDialogOpen,
    setIsDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    setErrorMessage,
    handleConfirm,
    handleCloseFraudChargeback,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    loadingFraudAndChargeback,
    error,
    isError,
    handleOpenPopUp,
    setLoading,
    handleSubmitWithFlag,
  };
};
